// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-attach {
  display: inline-block;
}
.button-attach__input {
  opacity: 0;
  position: absolute;
  clip: rect(0 0 0 0);
  width: 1px;
  height: 1px;
  margin: -1px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/ButtonAttach/ButtonAttach.scss"],"names":[],"mappings":"AASA;EACI,qBAAA;AARJ;AAUI;EAXA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAIJ","sourcesContent":[".button-attach {\n  display: inline-block;\n}\n.button-attach__input {\n  opacity: 0;\n  position: absolute;\n  clip: rect(0 0 0 0);\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
